<script lang="ts">
import { MessageContentType } from '@smartsupp/smartsupp-message'
import { getContext } from 'svelte'
import { fly } from 'svelte/transition'

import { testIds } from '@/constants'
import { contentListItemKey, type WritableMessageContext } from '@/modules/messages'
import { t } from '@/modules/translations'

import SystemMessageAgentContent from './SystemMessageAgentContent.svelte'
import SystemMessageChatbotContent from './SystemMessageChatbotContent.svelte'
import SystemMessageChatRating from './SystemMessageChatRating.svelte'
import SystemMessageInfo from './SystemMessageInfo.svelte'

const agentJoinedText = 'agentTransfer.joined'
const agentLeftText = 'agentTransfer.left'

let context = $derived(getContext<WritableMessageContext>(contentListItemKey))
let { message } = $derived($context)
let { createdAt } = $derived(message)

const getTestId = (contentType: MessageContentType): string => {
	const name = Object.keys(MessageContentType)[Object.values(MessageContentType).indexOf(contentType)]
	return `${testIds.systemMessage}${name}`
}
</script>

<div
	class="flex items-center my-4 text-gray-400"
	in:fly={{ duration: 350, x: -20 }}
	data-testid={getTestId(message.content.type)}
>
	{#if message.content.type === MessageContentType.AgentAssign}
		<SystemMessageAgentContent agentId={message.content.data.assigned} text={agentJoinedText} {createdAt} />
	{:else if message.content.type === MessageContentType.AgentUnassign}
		<SystemMessageAgentContent agentId={message.content.data.unassigned} text={agentLeftText} {createdAt} />
	{:else if message.content.type === MessageContentType.AgentJoin}
		<SystemMessageAgentContent agentId={message.content.data.agentId} text={agentJoinedText} {createdAt} />
	{:else if message.content.type === MessageContentType.AgentLeave}
		<SystemMessageAgentContent agentId={message.content.data.agentId} text={agentLeftText} {createdAt} />
	{:else if message.content.type === MessageContentType.ChatClose}
		{#if message.content.data.closeType === 'agent_close'}
			<SystemMessageAgentContent
				agentId={message.content.data.agentId}
				text={'systemMessage.chatResolved'}
				{createdAt}
			/>
		{:else}
			<SystemMessageChatbotContent {createdAt} />
		{/if}
	{:else if message.content.type === MessageContentType.ChatVisitorClose}
		<SystemMessageInfo text={$t('systemMessage.chatClosed')} />
	{:else if message.content.type === MessageContentType.RateForm}
		<SystemMessageChatRating
			{message}
			ratingValue={message.content.data?.value}
			ratingText={message.content.data?.text}
		/>
	{/if}
</div>
